<template>
  <div>
    <div class="contentModal">
      <div class="cardProcessPhoto"  v-show="$store.state.formPage == 4">
        <div class="title">
          <h3>Fotos da Embalagem do Molde</h3>
        </div>
        <div class="content">
          <AberturaEmbalagem
            v-if="configInputs == 0 || configInputs == 1"
            :configInputs="configInputs"
          />
        </div>
        <AberturaEmbalagemEdit
          v-if="configInputs == undefined"
          :configInputs="configInputs"
        />
      </div>

      <div class="cardProcessPhoto"  v-show="$store.state.formPage == 5">
        <div class="title">
          <h3>Fotos do Molde Fechado</h3>
        </div>
        <MoldeFechado
          v-if="configInputs == 0 || configInputs == 1"
          :configInputs="configInputs"
        />
        <MoldeFechadoEdit v-if="configInputs == undefined" />
      </div>

      <div class="cardProcessPhoto"  v-show="$store.state.formPage == 6">
        <div class="title">
          <h3>Fotos Molde Aberto</h3>
        </div>
        <MoldeAberto
          v-if="configInputs == 0 || configInputs == 1"
          :configInputs="configInputs"
        />
        <MoldeAbertoEdit
          v-if="configInputs == undefined"
          :configInputs="configInputs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AberturaEmbalagem from "./Modules/Abertura_Embalagem.vue";
import AberturaEmbalagemEdit from "./ModulesEdit/Abertura_Embalagem.vue";
import MoldeFechado from "./Modules/Molde-Fechado.vue";
import MoldeFechadoEdit from "./ModulesEdit/Molde-Fechado.vue";
import MoldeAberto from "./Modules/Molde-Aberto.vue";
import MoldeAbertoEdit from "./ModulesEdit/Molde-Aberto.vue";

export default {
  components: {
    AberturaEmbalagem,
    MoldeAberto,
    MoldeFechado,
    AberturaEmbalagemEdit,
    MoldeAbertoEdit,
    MoldeFechadoEdit,
  },
  props: {
    configInputs: Number,
  },
  methods: {
    incrementPage() {
      this.$store.commit('increment');
    }
  },
  data() {
    return {
      teste: "",
      DataAllImages: {
        AberturaEmbalagem: Object,
        MoldeFechado: Object,
        MoldeAberto: Object,
      },
    };
  },
};
</script>

<style scoped>
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.cardProcessPhoto {
  opacity: 0;
  animation: fadeIn 1s ease forwards!important;
}

.contentModal {
  margin: 0rem 2.5rem;
}

h3 {
  font-size: 0.8rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.title { 
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--font_color);

}

.content {
  display: flex;
  justify-content: center;
}


</style>
